export default __webpack_public_path__ + "static/media/Ellipse 22 (2).c7a63f28.png";